import useDropdown from '@customer/components/inputs/dropdown/useDropdown';
import { useAppSelector } from '@customer/store/hooks';
import { FiltersState } from '@customer/store/slices/filtersSlice';
import { ReactElement, Ref } from 'react';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import Field from '@cas/components/inputs/field/Field';
import Dropdown from '@cas/components/inputs/dropdown/Dropdown';
import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';

interface SingleSelectFilterProps<T> {
  filterName: keyof FiltersState;
  label: ReactElement | string;
  elementRef: Ref<HTMLVdsBasicDropdownElement>;
  action: ActionCreatorWithPayload<T>;
  useItemsHook: () => DropdownItemProps<T>[];
}

export const SingleSelectFilter = <T,>({
  filterName,
  label,
  elementRef,
  action,
  useItemsHook,
}: SingleSelectFilterProps<T>) => {
  // FIXME: Replace the type casting with type validation.
  const value: T = useAppSelector(state => state.filters.draft[filterName]) as T;

  const { items, onChange } = useDropdown<T>(useItemsHook, action);

  return (
    <Field uid={filterName} label={label}>
      <Dropdown<T>
        elementRef={elementRef}
        items={items}
        onChange={onChange}
        uid={filterName}
        value={value}
      />
    </Field>
  );
};

export default SingleSelectFilter;
